.nameFields {
	@apply yst-grid yst-grid-cols-1 sm:yst-grid-cols-2 yst-gap-4;
}

.includesLabel {
	@apply yst-font-medium yst-text-slate-800 yst-mb-1;
}

.checkmarkList {
	div {
		display: flex;
		align-items: center;
	}

	svg {
		@apply yst-fill-green-500;
		height: 14px;
		width: 14px;
		margin-right: 8px;
	}
}

.resultDetails {
	@apply yst-m-0;

	dt {
		@apply yst-font-medium yst-text-slate-800;
	}

	dd {
		@apply yst-m-0 yst-mb-3;
	}
}

.downloadList {
	@apply yst-flex yst-flex-col yst-gap-1 yst-m-0 yst-p-0 yst-list-none;
}
